import type { PrefetchedSmartlinkData } from '@jira/issue__fetch-services/src/fetchORSDataSSR.tsx';
import { getIssueKey } from '@jira/router-resources__utils/src/getIssueKey.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getIssueAttachmentsSmartlinkData } from './getIssueAttachmentsSmartlinkData.tsx';

export const issueAttachmentsSmartlinkDataResource: RouteResource<
	PrefetchedSmartlinkData[] | null
> = createResource<PrefetchedSmartlinkData[] | null>({
	type: 'ISSUE_ATTACHMENTS_SMARTLINK_DATA',
	getKey: ({ match }) => getIssueKey(match) ?? '',
	getData: (...args) => getIssueAttachmentsSmartlinkData(...args),
});
